"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarxentApp = void 0;
var react_1 = __importDefault(require("react"));
var test_attributes_1 = require("@hip/test-attributes");
var marxentApp_module_css_1 = __importDefault(require("./marxentApp.module.css"));
// eslint-disable-next-line react/display-name
exports.MarxentApp = react_1.default.forwardRef(function (_, ref) { return (react_1.default.createElement("div", { ref: ref, className: marxentApp_module_css_1.default.Container, "data-test-id": test_attributes_1.dataTestId.configurator.layout.marxentAppContainer })); });
